import { addSuccessSnack, addErrorSnack } from './snackbar';
import i18n from '../i18n';

export function copyToClipboard(text, success, error) {
  if (!text) return;
  if (!success) success = i18n.t('Kopierad till urklipp');
  if (!error) error = i18n.t('Kunde inte kopiera till urklipp');
  // Copy email to clipboard
  try {
    navigator.clipboard.writeText(text);
    addSuccessSnack(success);
  } catch (err) {
    addErrorSnack(error);
  }
}
